module.exports = __webpack_public_path__ + "static/media/cherry_hill_village.c1100700.pdf";